import React, { FC } from 'react';
import { Skeleton } from 'fronton-react/unstable';
import { jcm } from 'utils';
import { dataIsLoadingCommon } from 'features/product-info/components/pdp-showcase/styles';
import { PdpProductTitle } from 'features/product-info/components/pdp-product-title';
import {
  ProductTitleContainer,
  SkeletonRows,
  skuSkeleton,
  titleSkeleton,
  TitleWithWishlist,
} from './styles';

export const DATA_QA_PRODUCT_TITLE = 'product-title_mf-pdp';

type Props = {
  productDataIsLoading: boolean;
};

export const ProductTitle: FC<Props> = ({ productDataIsLoading }) => {
  return (
    <ProductTitleContainer data-qa={DATA_QA_PRODUCT_TITLE}>
      <TitleWithWishlist>
        {productDataIsLoading ? (
          <SkeletonRows>
            <Skeleton width={'112px'} height={'var(--space-200)'} className={skuSkeleton} />
            <Skeleton width={'264px'} height={'var(--space-525)'} className={titleSkeleton} />
          </SkeletonRows>
        ) : (
          <>
            <PdpProductTitle
              className={jcm({
                [dataIsLoadingCommon]: productDataIsLoading,
              })}
            />
          </>
        )}
      </TitleWithWishlist>
    </ProductTitleContainer>
  );
};
